import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import reviews from '../data/reviews';
import '../css/Reviews.css';
import Header from '../components/Header';
import Footer from './footer/Footer';

const Reviews = () => {
    return (
        <>
            <Helmet>
                <title>Nos avis - CC Débarras 14</title>
                <meta name="description" content="Découvrez tous les avis de nos clients sur CC Débarras 14, service de débarras professionnel à Deauville et environs." />
                <link rel="canonical" href="https://ccdebarras14.fr/nos-avis" />
            </Helmet>

            <Header />

            <div className="reviews-page-component">
                <div className="reviews-page-header">
                    <h1>Nos avis</h1>
                    <p>Ce que nos clients pensent de nos services de débarras.</p>
                    <Link to="/laisser-un-avis" className="reviews-page-cta">Laisser un avis</Link>
                </div>

                <div className="reviews-page-grid">
                    {reviews.map((review, index) => (
                        <div key={index} className="reviews-page-card">
                            <span className="reviews-page-quote">”</span>
                            <div className="reviews-page-stars">
                                {"★".repeat(review.rating)}
                            </div>
                            <p>{review.text}</p>
                            <div className="reviews-page-footer">
                                <div className="reviews-page-avatar">
                                    {review.author_name.charAt(0)}
                                </div>
                                <div className="reviews-page-identity">
                                    <span className="reviews-page-author">{review.author_name}</span>
                                    <span className="reviews-page-source">Avis {review.source}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Reviews;
